var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_vm.topTagList),function(tag,index){return _c('li',{key:index},[(_setup.tagData(tag))?_c('span',{class:['badge artwork', `${tag?.className}`]},[_vm._v("\n      "+_vm._s(_setup.tagData(tag)?.text))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }